import React from 'react';
import { Container } from './ui/Container';
import { Button } from './ui/Button';
import { CheckIcon, ShieldCheckIcon, DownloadIcon } from 'lucide-react';
export function PricingSection() {
  const handleAddToCart = () => {
    // Fire Meta Pixel AddToCart event
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'RESET 3AM',
        content_ids: ['56770924904796'],
        content_type: 'product',
        value: 6.39,
        currency: 'USD'
      });
    }
  };
  return <section id="pricing" className="py-24 bg-slate-900 relative overflow-hidden" data-id="element-88">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-full max-h-[600px] bg-indigo-900/20 blur-3xl rounded-full pointer-events-none" data-id="element-89"></div>

      <Container className="relative z-10" data-id="element-90">
        <div className="max-w-lg mx-auto bg-slate-950 rounded-2xl border border-indigo-500/30 shadow-2xl shadow-indigo-900/20 overflow-hidden" data-id="element-91">
          <div className="p-8 md:p-10 text-center border-b border-slate-800" data-id="element-92">
            <h2 className="text-3xl font-bold text-white mb-2" data-id="element-93">RESET 3AM</h2>
            <p className="text-indigo-300 mb-6" data-id="element-94">Kit Digital + Imprimibles</p>

            <div className="flex items-center justify-center gap-3 mb-2" data-id="element-95">
              <span className="text-slate-500 text-2xl line-through" data-id="element-96">
                $19.99
              </span>
              <span className="font-bold text-white text-[48px]" data-id="element-97">$6.39</span>
              <span className="text-slate-400 text-lg self-end mb-1" data-id="element-98">USD</span>
            </div>
            <p className="text-slate-500 text-sm" data-id="element-99">
              Pago único. Acceso inmediato.
            </p>
          </div>

          <div className="p-8 md:p-10 bg-slate-900/50" data-id="element-100">
            <p className="text-slate-300 mb-6 font-medium" data-id="element-101">
              Todo lo que incluye:
            </p>
            <ul className="space-y-4 mb-8" data-id="element-102">
              {['Ebook RESET 3AM (Guía completa)', 'Tarjeta 4D imprimible (Para la mesita de noche)', 'Checklist "Mesita de Noche" (Preparación de 2 min)', 'Plantilla "Descarga mental" (Para cortar el loop)', 'Plan de 7 noches (Para automatizarlo)'].map((item, i) => <li key={i} className="flex items-start text-slate-300 text-sm md:text-base" data-id="element-103">
                  <CheckIcon className="w-5 h-5 text-indigo-400 mr-3 shrink-0" data-id="element-104" />
                  <span data-id="element-105">{item}</span>
                </li>)}
            </ul>

            <Button fullWidth size="lg" className="mb-4 text-lg group" href="https://primepickbay.com/cart/56770924904796:1" onClick={handleAddToCart} data-id="element-106">
              <DownloadIcon className="w-5 h-5 mr-2 group-hover:-translate-y-1 transition-transform" data-id="element-107" />
              Descargar RESET 3AM ahora
            </Button>

            <div className="flex items-center justify-center gap-2 text-xs text-slate-500" data-id="element-108">
              <ShieldCheckIcon className="w-4 h-4" data-id="element-109" />
              <span data-id="element-110">Compra segura · Entrega digital inmediata</span>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center max-w-2xl mx-auto" data-id="element-111">
          <p className="text-slate-400 italic" data-id="element-112">
            "Si esta noche vuelves a abrir los ojos a las 3AM, no quiero que
            vuelvas a improvisar. Quiero que tengas una hoja al alcance de tu
            mano y digas: 'Ok. Ya sé qué hacer.'"
          </p>
        </div>
      </Container>
    </section>;
}